import { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

export interface SearchParams {
  serviceName?: string;
  circulationDate?: string;
  [key: string]: string | undefined;
}

const useUrlParams = ({ clearAfterRead }: { clearAfterRead?: boolean }) => {
  const location = useLocation();
  const [urlParams, setUrlParams] = useState<SearchParams | null>(null);
  const [hasProcessedParams, setHasProcessedParams] = useState(false);

  const processParams = useCallback(() => {
    if (!hasProcessedParams) {
      const searchParams = new URLSearchParams(location.search);
      const params: SearchParams = {};

      searchParams.forEach((value, key) => {
        params[key] = value || undefined;
      });

      setUrlParams(params);
      setHasProcessedParams(true);

      if (clearAfterRead && location.search) {
        /**
         * Clear the history state to avoid unintended persistence
         * We use replaceState to avoid triggering a new history entry
         */
        window.history.replaceState(null, '', location.pathname);
      }
    }
  }, [clearAfterRead, location.pathname, location.search, hasProcessedParams]);

  useEffect(() => {
    processParams();
  }, [processParams]);

  return urlParams;
};

export default useUrlParams;
